import positionActions from "../../../actions/positionActions";
import positionTableColumns, {
  positionTableLeftFixedColumns,
  positionTableSummaries,
} from "./positionTableColumns";
import generateEntityTable from "../../../hocs/generateEntityTable";

const PositionsTable = generateEntityTable({
  entityPluralString: "clientPositions",
  entityActions: positionActions,
  columns: positionTableColumns,
  leftFixedColumns: positionTableLeftFixedColumns,
  operations: [],
  summaries: positionTableSummaries,
  // walletBalancingOperation: true,
  // walletBalancingRoutePath: "/client-wallet-balancing/:id",
});

export default PositionsTable;
